module.exports = __webpack_public_path__ + "images/feature/calendar-4-e82e844ece24bfa61918b6c388d52940.png";